import { ENV } from 'config';

import { AnalyticsConfig, AnalyticsProvider } from './types';

let active = false;

const GA: AnalyticsProvider = {
    init: (config: AnalyticsConfig) => {
        if (!ENV.GA_ID || !config.clarityEnabled) {
            return;
        }

        const tag = document.createElement('script');
        tag.async = true;
        tag.src = `https://www.googletagmanager.com/gtag/js?id=${ ENV.GA_ID }`;
        const script = document.getElementsByTagName('script')[0];
        // @ts-ignore
        script.parentNode.insertBefore(tag, script);

        // @ts-ignore
        window.dataLayer = window.dataLayer || [];

        window.gtag = window.gtag || function () {
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };

        window.gtag('js', new Date());
        /* eslint-disable camelcase */
        window.gtag('config', ENV.GA_ID, {
            tenant: config.tenant,
            user_id: config.userId,
            ...config.properties
        });
        /* eslint-enable camelcase */

        active = true;
    },
    event: (name: string, data?: Record<string, unknown>) => {
        if (active && typeof window.gtag === 'function') {
            window.gtag('event', name, data);
        }
    }
};

export default GA;
